import request from "../utils/request";

// 考试题目
export function examQuestion(data) {
  return request({
    auth: false,
    url: "/pc/video/exam/question",
    method: "get",
    data,
  });
}

// 考试题目提交
export function examCommit(data) {
  return request({
    auth: false,
    url: "/pc/video/exam/commit",
    method: "post",
    data,
  });
}

//答题情况 
export function examSituation(params) {
  return request({
    auth: false,
    url: "/pc/video/results",
    method: "get",
    params,
  });
}
